import React from 'react';

import './OptionsButtons.scss';

type Props = {
  onEditClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onDeleteClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

function OptionsButtons({ onEditClick, onDeleteClick }: Props) {
  return (
    <div className="options-buttons d-flex ml-auto">
      <button type="button" className="options-buttons-edit btn py-1 px-0 text-muted" onClick={onEditClick}>
        Edit
      </button>
      <div className="py-1 mx-1 text-muted">|</div>
      <button type="button" className="options-buttons-delete btn py-1 px-0 text-muted" onClick={onDeleteClick}>
        Delete
      </button>
    </div>
  );
}

export default OptionsButtons;
